import { useTheme } from "@hooks/useTheme";
import { PrimaryButton } from "@components/Buttons";
import OutlineButton from "@components/Buttons/OutlineButton";
import { WarningIcon } from "@components/Icons";

import { useTranslation } from "react-i18next";

const NoVerificationFileErrorModal = ({
  isOpen,
  onDelete,
  onGoBack,
  "data-testid": dataTestId = "no-verification-file-error-modal",
}) => {
  const fieldValueTestId = (name) => `${dataTestId}-field-${name}-value`;
  const { colors } = useTheme();
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 ${colors.bgBlurModal} z-50 flex items-center justify-center backdrop-blur-[1px]`}
      data-testid={`${dataTestId}-overlay`}
    >
      <div
        className={`${colors.bgModal} w-[90vw] max-w-lg flex-shrink-0 rounded-xl shadow-xl border ${colors.borderPrimary}`}
        data-testid={dataTestId}
      >
        {/* Content */}
        <div className="p-8 text-center" data-testid={`${dataTestId}-content`}>
          {/* Warning Icon */}
          <div className="flex justify-center mb-4" data-testid={`${dataTestId}-icon`}>
            <WarningIcon size="80" />
          </div>

          {/* Title */}
          <h2 className={`${colors.textPrimary} text-2xl font-bold mb-4 uppercase`} data-testid={`${dataTestId}-title`}>
            {t("common.cannot-save")}
          </h2>

          {/* Message */}
          <p
            className={`${colors.textSecondary} text-sm leading-relaxed mb-8`}
            data-testid={fieldValueTestId("message")}
          >
            {t("project.sbom-merged.empty-merge-project-versions-err-msg")}
          </p>

          {/* Action Buttons */}
          <div className="flex space-x-4" data-testid={`${dataTestId}-footer`}>
            <OutlineButton
              data-testid={`${dataTestId}-delete-button`}
              onClick={onDelete}
              className={`flex-1 ${colors.borderDangerSubtle} justify-center ${colors.textDangerSubtle} hover:opacity-80`}
              size="lg"
            >
              {t("project.sbom-merged.delete-merged-sbom")}
            </OutlineButton>
            <PrimaryButton
              data-testid={`${dataTestId}-go-back-button`}
              onClick={onGoBack}
              className="flex-1"
              size="lg"
            >
              {t("notFound.go-back")}
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoVerificationFileErrorModal;
